// OneDrive:IgnoreCodeCoverage

export * from '@ms/telemetry-manager/lib/events/Verbose.event';
export { Verbose as default } from '@ms/telemetry-manager/lib/events/Verbose.event';
